import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { isValidElement } from 'react';
import Button from '../Button/Button.es.js';
import { IconButton } from '../IconButton/IconButton.es.js';
import { Text } from '../Text/Text.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var InputGroupAddon = function InputGroupAddon(_ref) {
  var children = _ref.children;
  return (
    /* @__PURE__ */
    React.createElement(React.Fragment, null, children)
  );
};

var addonSpacingProps = function addonSpacingProps(placement) {
  return placement === "left" ? {
    ml: "sm"
  } : {
    mr: "sm"
  };
};

var InputGroupIcon = function InputGroupIcon(_a) {
  var _b = _a,
      placement = _b.placement,
      children = _b.children,
      props = __objRest(_b, ["placement", "children"]);

  var spacingProps = addonSpacingProps(placement);

  if (!
  /*#__PURE__*/
  isValidElement(children)) {
    return (
      /* @__PURE__ */
      React.createElement(React.Fragment, null)
    );
  }

  return (
    /*#__PURE__*/
    React.cloneElement(children, __spreadValues(__spreadValues(__spreadValues({}, spacingProps), props), children.props))
  );
};

InputGroupIcon.displayName = "InputGroup.Addon";
var InputGroupButton = forwardRef(function (props, ref) {
  return (
    /* @__PURE__ */
    React.createElement(Button, __spreadValues({
      ref: ref
    }, props))
  );
});
InputGroupButton.displayName = "InputGroup.Addon";
var InputGroupIconButton = forwardRef(function (props, ref) {
  return (
    /* @__PURE__ */
    React.createElement(IconButton, __spreadValues({
      ref: ref
    }, props))
  );
});
InputGroupIconButton.displayName = "InputGroup.Addon";

var InputGroupText = function InputGroupText(_c) {
  var _d = _c,
      placement = _d.placement,
      props = __objRest(_d, ["placement"]);

  var spacingProps = addonSpacingProps(placement);
  return (
    /* @__PURE__ */
    React.createElement(Text, __spreadValues(__spreadValues({}, spacingProps), props))
  );
};

InputGroupText.displayName = "InputGroup.Addon";
export { InputGroupAddon, InputGroupButton, InputGroupIcon, InputGroupIconButton, InputGroupText };